import { render, staticRenderFns } from "./BubbleFormat.vue?vue&type=template&id=35c64ff4&scoped=true&"
import script from "./BubbleFormat.vue?vue&type=script&lang=js&"
export * from "./BubbleFormat.vue?vue&type=script&lang=js&"
import style0 from "./BubbleFormat.vue?vue&type=style&index=0&id=35c64ff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c64ff4",
  null
  
)

export default component.exports